<template>
	<div class="upload-container" v-loading.fullscreen.lock="loading">
		<el-button :style="{background:color,borderColor:color}" icon="el-icon-upload" size="mini" type="primary" @click="dialogVisible=true">上傳圖片</el-button>
		<el-dialog :visible.sync="dialogVisible">
			<el-upload :action="postURL" :multiple="true" :file-list="fileList" :show-file-list="true" :on-remove="handleRemove" :on-success="handleSuccess" :before-upload="beforeUpload" class="editor-slide-upload" list-type="picture-card">
				<el-button size="small" type="primary">點擊上傳</el-button>
			</el-upload>
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">確 定</el-button>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import API from "@/api";

export default {
	name: 'EditorSlideUpload',
	props: {
		color: {
			type: String,
			default: '#1890ff'
		}
	},
	data() {
		return {
			dialogVisible: false,
			listObj: {},
			fileList: [],
			loading: false
		}
	},
	computed: {
		postURL() {
			return `${API.baseURL}/api/upload/image/notification`;
		},
	},
	methods: {
		checkAllSuccess() {
			return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
		},
		handleSubmit() {
			const arr = Object.keys(this.listObj).map(v => this.listObj[v])
			if (!this.checkAllSuccess()) {
				this.$message('請等待所有圖片上傳成功 或 出現了網絡問題，請刷新頁面重新上傳！')
				return
			}
			this.$emit('successCBK', arr)
			this.listObj = {}
			this.fileList = []
			this.dialogVisible = false
		},
		handleSuccess(response, file) {
			this.loading = false;
			const uid = file.uid
			const objKeyArr = Object.keys(this.listObj)
			for (let i = 0, len = objKeyArr.length; i < len; i++) {
				if (this.listObj[objKeyArr[i]].uid === uid) {
					this.listObj[objKeyArr[i]].url = response.Location
					this.listObj[objKeyArr[i]].hasSuccess = true
					return
				}
			}
		},
		handleRemove(file) {
			const uid = file.uid
			const objKeyArr = Object.keys(this.listObj)
			for (let i = 0, len = objKeyArr.length; i < len; i++) {
				if (this.listObj[objKeyArr[i]].uid === uid) {
					delete this.listObj[objKeyArr[i]]
					return
				}
			}
		},
		beforeUpload(file) {
			this.loading = true;
			const _self = this
			const _URL = window.URL || window.webkitURL
			const fileName = file.uid
			this.listObj[fileName] = {}
			return new Promise((resolve, reject) => {
				const img = new Image()
				img.src = _URL.createObjectURL(file)
				img.onload = function () {
					_self.listObj[fileName] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height }
				}
				resolve(true)
			})
		}
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
	margin-bottom: 20px;
	/deep/ .el-upload--picture-card {
		width: 100%;
	}
}
</style>
